import React, { useCallback } from 'react'
import { roleHooks } from '.'
import { LightButton, LightButton2 } from 'styles/GlobalStyle'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { SelectRoleBtnStyles } from './Style'

const SelectDefaultRoleBtn = (props) => {
    const { role } = props
    const { user } = useSelector(state => state.user)
    const navigate = useNavigate()

    const updateDefaultRole = roleHooks.useUpdateDefaultRole()

    const selectDefaultRole = useCallback((role) => {
        updateDefaultRole(role)
        navigate(app.app)
    }, [user])

    return (
        <SelectRoleBtnStyles>
            <div className='select-role'>
                <LightButton
                    variant="solid"
                    fullWidth
                    label="הגדר כברירת מחדל"
                    size="small"
                    className="select-role-btn"
                    action={(_, e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        selectDefaultRole(role)
                    }}
                />
            </div>
        </SelectRoleBtnStyles>
    )
}

export default SelectDefaultRoleBtn